import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
}
export const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  align = 'center'
}) => {
  return <div className={`mb-12 ${align === 'center' ? 'text-center' : 'text-left'}`} data-id="element-131">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="text-4xl md:text-5xl font-black mb-4" data-id="element-132">
        {title}
      </motion.h2>
      {subtitle && <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="text-xl md:text-2xl font-medium max-w-2xl mx-auto" data-id="element-133">
          {subtitle}
        </motion.p>}
    </div>;
};